import { accounting } from "~/types/Permissions/Accounting";
import { announcements } from "~/types/Permissions/Announcements";
import { candidateSelection } from "~/types/Permissions/CandidateSelection";
import { competitiveTerritories } from "~/types/Permissions/CompetitiveTerritories";
import { dealer } from "~/types/Permissions/Dealer";
import { dealergraph } from "~/types/Permissions/Dealergraph";
import { dealers } from "~/types/Permissions/Dealers";
import { directions } from "~/types/Permissions/Directions";
import { documents } from "~/types/Permissions/Documents";
import { employeeAccounting } from "~/types/Permissions/EmployeeAccounting";
import { globalRatings } from "~/types/Permissions/GlobalRatings";
import { indicator } from "~/types/Permissions/Indicator";
import { indicatorGroupReports } from "~/types/Permissions/IndicatorGroupReports";
import { ivideon } from "~/types/Permissions/Ivideon";
import { log } from "~/types/Permissions/Log";
import { photoGallery } from "~/types/Permissions/PhotoGallery";
import { pkd } from "~/types/Permissions/PKD";
import { quartilesRatings } from "~/types/Permissions/QuartilesRatings";
import { srr } from "~/types/Permissions/Srr";
import { subdivisions } from "~/types/Permissions/Subdivisions";
import { user_guides } from "~/types/Permissions/User_guides";
import { users } from "~/types/Permissions/Users";
import { violations } from "~/types/Permissions/Violations";
import { violationsTypes } from "~/types/Permissions/ViolationsTypes";
import { zd } from "~/types/Permissions/ZD";

import { addressSelectionGuide } from "./AddressSelectionGuide";
import { combinationRules } from "./CombinationRules";
import { contracts } from "./Contracts";
import { dealerIndicator } from "./DealerIndicator";
import { editorContracts } from "./EditorContracts";
import { passport } from "./Passport";

export const permissionAliases = {
  ...users,
  ...subdivisions,
  ...violations,
  ...violationsTypes,
  ...ivideon,
  ...dealer,
  ...dealers,
  ...announcements,
  ...documents,
  ...accounting,
  ...srr,
  ...indicatorGroupReports,
  ...zd,
  ...globalRatings,
  ...quartilesRatings,
  ...dealergraph,
  ...indicator,
  ...log,
  ...photoGallery,
  ...candidateSelection,
  ...competitiveTerritories,
  ...employeeAccounting,
  ...user_guides,
  ...pkd,
  ...directions,
  ...contracts,
  ...editorContracts,
  ...addressSelectionGuide,
  ...dealerIndicator,
  ...combinationRules,
  ...passport,
} as const;

export type PermissionKey = keyof typeof permissionAliases;
